// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { motion } from "framer-motion";
// import {
//   Send,
//   Phone,
//   Mail,
//   MapPin,
//   ArrowRight,
//   ShieldCheck,
//   Clock,
//   Globe2,
//   Activity
// } from "lucide-react";
// import { Api } from "../Api/Api";

// const fadeUp = {
//   initial: { opacity: 0, y: 20 },
//   whileInView: { opacity: 1, y: 0 },
//   viewport: { once: true },
//   transition: { duration: 0.6 },
// };

// const ContactPage = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     company: "",
//     service: "",
//   });

//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       await axios.post(`${Api}/Contact.php`, formData);
//       Swal.fire({
//         title: "Transmission Successful",
//         text: "Our engineering lead will review your inquiry shortly.",
//         icon: "success",
//         confirmButtonColor: "#4f46e5",
//       });
//       setFormData({ name: "", email: "", phone: "", company: "", service: "" });
//     } catch (error) {
//       Swal.fire(
//         "Error!",
//         "Failed to establish connection. Please try again.",
//         "error",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <main className="min-h-screen bg-white font-inter selection:bg-indigo-100 text-slate-900">
//       {/* ================= HERO SECTION ================= */}
//       <section className="relative h-[400px] flex items-center overflow-hidden bg-[#0f172a]">
//         <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/90 to-transparent z-10" />
//         <div
//           className="absolute inset-0 opacity-[0.05] pointer-events-none z-10"
//           style={{
//             backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
//             backgroundSize: "30px 30px",
//           }}
//         />

//         <div className="relative max-w-7xl mx-auto px-6 w-full z-20">
//           <motion.div
//             initial={{ opacity: 0, x: -20 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.8 }}
//           >
//             <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
//               Establish Connection
//             </div>
//             <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 tracking-tight">
//               Initiate a{" "}
//               <span className="text-indigo-400">Technical Inquiry.</span>
//             </h1>
//             <p className="text-lg text-slate-300 max-w-xl font-light leading-relaxed">
//               Connect with our architecture team to discuss your software
//               ecosystem, data training requirements, or digital migration.
//             </p>
//           </motion.div>
//         </div>
//       </section>

//       {/* ================= CONTACT INTERFACE ================= */}
//       <section className="py-24 relative -mt-20 z-30">
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="grid lg:grid-cols-12 gap-8 items-stretch">
//             {/* Left: Contact Info Matrix */}
//             <motion.div {...fadeUp} className="lg:col-span-4 space-y-4">
//               <div className="bg-[#0f172a] p-10 rounded-[2.5rem] text-white h-full relative overflow-hidden shadow-2xl">
//                 <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-500/10 blur-3xl" />
//                 <h3 className="text-2xl font-bold mb-10 tracking-tight">
//                   Connect Channels
//                 </h3>

//                 <div className="space-y-8">
//                   {[
//                     {
//                       icon: Mail,
//                       label: "Official Correspondence",
//                       value: "info@infronex.com",
//                     },
//                     {
//                       icon: Phone,
//                       label: "Technical Support",
//                       value: "+91 (Voice / WhatsApp)",
//                     },
//                     {
//                       icon: MapPin,
//                       label: "Global Headquarters",
//                       value: "Coimbatore, Tamil Nadu, India",
//                     },
//                   ].map((item, i) => (
//                     <div key={i} className="flex gap-5 group">
//                       <div className="w-10 h-10 shrink-0 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center text-indigo-400 group-hover:bg-indigo-600 group-hover:text-white transition-all">
//                         <item.icon size={18} />
//                       </div>
//                       <div>
//                         <p className="text-[10px] font-black text-indigo-400 uppercase tracking-widest mb-1">
//                           {item.label}
//                         </p>
//                         <p className="text-sm text-slate-300 font-medium">
//                           {item.value}
//                         </p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>

//                 <div className="mt-16 pt-10 border-t border-white/5 space-y-4">
//                   <div className="flex items-center gap-3 text-slate-400 text-xs font-medium">
//                     <Clock size={14} className="text-indigo-400" />
//                     <span>Response Time: &lt; 24 Hours</span>
//                   </div>
//                   <div className="flex items-center gap-3 text-slate-400 text-xs font-medium">
//                     <ShieldCheck size={14} className="text-indigo-400" />
//                     <span>ISO & SOC2 Compliant Handling</span>
//                   </div>
//                 </div>
//               </div>
//             </motion.div>

//             {/* Right: Engineering Intake Form */}
//             <motion.div
//               {...fadeUp}
//               transition={{ delay: 0.2 }}
//               className="lg:col-span-8"
//             >
//               <div className="bg-white p-8 md:p-12 rounded-[2.5rem] border border-slate-100 shadow-xl shadow-slate-200/50">
//                 <form onSubmit={handleSubmit} className="space-y-6">
//                   <div className="grid md:grid-cols-2 gap-6">
//                     <div className="space-y-2">
//                       <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
//                         Full Name
//                       </label>
//                       <input
//                         type="text"
//                         name="name"
//                         value={formData.name}
//                         onChange={handleChange}
//                         required
//                         className="w-full bg-slate-50 border border-slate-100 rounded-2xl px-5 py-4 text-sm focus:outline-none focus:border-indigo-500 focus:bg-white transition-all"
//                         placeholder="John Doe"
//                       />
//                     </div>
//                     <div className="space-y-2">
//                       <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
//                         Corporate Email
//                       </label>
//                       <input
//                         type="email"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleChange}
//                         required
//                         className="w-full bg-slate-50 border border-slate-100 rounded-2xl px-5 py-4 text-sm focus:outline-none focus:border-indigo-500 focus:bg-white transition-all"
//                         placeholder="john@company.com"
//                       />
//                     </div>
//                   </div>

//                   <div className="grid md:grid-cols-2 gap-6">
//                     <div className="space-y-2">
//                       <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
//                         Phone Reference
//                       </label>
//                       <input
//                         type="tel"
//                         name="phone"
//                         value={formData.phone}
//                         onChange={handleChange}
//                         required
//                         className="w-full bg-slate-50 border border-slate-100 rounded-2xl px-5 py-4 text-sm focus:outline-none focus:border-indigo-500 focus:bg-white transition-all"
//                         placeholder="+91 00000 00000"
//                       />
//                     </div>
//                     <div className="space-y-2">
//                       <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
//                         Organization
//                       </label>
//                       <input
//                         type="text"
//                         name="company"
//                         value={formData.company}
//                         onChange={handleChange}
//                         className="w-full bg-slate-50 border border-slate-100 rounded-2xl px-5 py-4 text-sm focus:outline-none focus:border-indigo-500 focus:bg-white transition-all"
//                         placeholder="Enter Enterprise Name"
//                       />
//                     </div>
//                   </div>

//                   <div className="space-y-2">
//                     <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
//                       Inquiry Vector
//                     </label>
//                     <textarea
//                       name="service"
//                       value={formData.service}
//                       onChange={handleChange}
//                       required
//                       className="w-full bg-slate-50 border border-slate-100 rounded-2xl px-5 py-4 text-sm h-32 focus:outline-none focus:border-indigo-500 focus:bg-white transition-all resize-none"
//                       placeholder="Discuss your CRM infrastructure, AI data needs, or cloud migration requirements..."
//                     ></textarea>
//                   </div>

//                   <button
//                     type="submit"
//                     disabled={loading}
//                     className="w-full bg-indigo-600 text-white py-4 rounded-2xl font-bold text-sm hover:bg-indigo-700 transition-all shadow-lg shadow-indigo-900/20 flex items-center justify-center gap-3"
//                   >
//                     {loading ? (
//                       <span className="flex items-center gap-2">
//                         <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
//                         Synchronizing...
//                       </span>
//                     ) : (
//                       <>
//                         Transmit Message <Send size={16} />
//                       </>
//                     )}
//                   </button>
//                 </form>
//               </div>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* ================= GLOBAL REACH MAP SECTION ================= */}
//       <section className="py-24 bg-slate-50 border-t border-slate-100">
//         <div className="max-w-7xl mx-auto px-6 text-center">
//           <div className="grid lg:grid-cols-2 gap-16 items-center">
//             <div className="text-left">
//               <h2 className="text-3xl font-bold text-slate-900 mb-6 tracking-tight">
//                 Our Base of Operations
//               </h2>
//               <p className="text-slate-500 font-light leading-relaxed mb-8">
//                 Operating from the engineering hub of **Coimbatore**, we support
//                 global enterprises with high-fidelity software ecosystems and
//                 multilingual data translators.
//               </p>
//               <div className="flex flex-wrap gap-4">
//                 <div className="px-4 py-2 bg-white border border-slate-200 rounded-xl flex items-center gap-3 text-xs font-bold text-slate-600">
//                   <Globe2 size={16} className="text-indigo-600" /> Remote Ready
//                 </div>
//                 <div className="px-4 py-2 bg-white border border-slate-200 rounded-xl flex items-center gap-3 text-xs font-bold text-slate-600">
//                   <Activity size={16} className="text-indigo-600" /> 24/7
//                   Monitoring
//                 </div>
//               </div>
//             </div>
//             <div className="h-64 bg-slate-200 rounded-[2.5rem] relative overflow-hidden group">
//               <div className="absolute inset-0 bg-[#0f172a] flex items-center justify-center">
//                 <div className="text-indigo-500 opacity-20">
//                   <MapPin size={120} strokeWidth={0.5} />
//                 </div>
//                 <div className="absolute text-center z-10">
//                   <p className="text-indigo-400 font-black text-xs uppercase tracking-[0.4em]">
//                     Infronex Labs
//                   </p>
//                   <p className="text-white font-bold text-xl">
//                     Tamil Nadu, India
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </main>
//   );
// };

// export default ContactPage;

import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { motion } from "framer-motion";
import {
  Send,
  Phone,
  Mail,
  MapPin,
  ArrowRight,
  ShieldCheck,
  Clock,
  Globe2,
  Activity,
  Terminal,
} from "lucide-react";
import { Api } from "../Api/Api";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    service: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Technical Validation: Strictly allow only 10 digits for the phone field
    if (name === "phone") {
      const onlyNums = value.replace(/[^0-9]/g, "");
      if (onlyNums.length <= 10) {
        setFormData((prev) => ({ ...prev, [name]: onlyNums }));
      }
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.phone.length !== 10) {
      Swal.fire(
        "Validation Error",
        "Please enter a valid 10-digit phone number.",
        "warning",
      );
      return;
    }
    setLoading(true);

    try {
      await axios.post(`${Api}/Contact.php`, formData);
      Swal.fire({
        title: "Transmission Successful",
        text: "Our engineering lead will review your inquiry shortly.",
        icon: "success",
        confirmButtonColor: "#4f46e5",
      });
      setFormData({ name: "", email: "", phone: "", company: "", service: "" });
    } catch (error) {
      Swal.fire(
        "Error!",
        "Failed to establish connection. Please try again.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-white font-inter selection:bg-indigo-100 text-slate-900">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[400px] flex items-center overflow-hidden bg-[#0f172a]">
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/90 to-transparent z-10" />
        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none z-10"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 w-full z-20">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
              Establish Connection
            </div>
            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 tracking-tight">
              Initiate a{" "}
              <span className="text-indigo-400">Technical Inquiry.</span>
            </h1>
            <p className="text-lg text-slate-300 max-w-xl font-light leading-relaxed">
              Connect with our Coimbatore architecture team to discuss your
              software ecosystem, data training requirements, or digital
              migration.
            </p>
          </motion.div>
        </div>
      </section>

      {/* ================= CONTACT INTERFACE ================= */}
      <section className="py-24 relative -mt-20 z-30">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-12 gap-8 items-stretch">
            {/* Left: Contact Info Matrix */}
            <motion.div {...fadeUp} className="lg:col-span-4 space-y-4">
              <div className="bg-[#0f172a] p-10 rounded-[2.5rem] text-white h-full relative overflow-hidden shadow-2xl">
                <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-500/10 blur-3xl" />
                <h3 className="text-2xl font-bold mb-10 tracking-tight">
                  Connect Channels
                </h3>

                <div className="space-y-8">
                  <div className="flex gap-5 group">
                    <div className="w-10 h-10 shrink-0 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center text-indigo-400 group-hover:bg-indigo-600 group-hover:text-white transition-all">
                      <Mail size={18} />
                    </div>
                    <div>
                      <p className="text-[10px] font-black text-indigo-400 uppercase tracking-widest mb-1">
                        Official Correspondence
                      </p>
                      <p className="text-sm text-slate-300 font-medium italic">
                        info@infronex.com
                      </p>
                    </div>
                  </div>

                  <div className="flex gap-5 group">
                    <div className="w-10 h-10 shrink-0 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center text-indigo-400 group-hover:bg-indigo-600 group-hover:text-white transition-all">
                      <Phone size={18} />
                    </div>
                    <div>
                      <p className="text-[10px] font-black text-indigo-400 uppercase tracking-widest mb-1">
                        Technical Support
                      </p>
                      <p className="text-sm text-slate-300 font-medium">
                        +91 8248387513, 9940932308
                      </p>
                    </div>
                  </div>

                  <div className="flex gap-5 group">
                    <div className="w-10 h-10 shrink-0 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center text-indigo-400 group-hover:bg-indigo-600 group-hover:text-white transition-all">
                      <MapPin size={18} />
                    </div>
                    <div>
                      <p className="text-[10px] font-black text-indigo-400 uppercase tracking-widest mb-1">
                        Global Headquarters
                      </p>
                      <p className="text-sm text-slate-300 font-medium leading-relaxed uppercase tracking-tighter">
                        72/3, SRP Mill Bus stop, Saravanampatti,
                        Coimbatore-641035
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mt-16 pt-10 border-t border-white/5 space-y-4">
                  <div className="flex items-center gap-3 text-slate-400 text-xs font-medium uppercase tracking-widest italic">
                    <Clock size={14} className="text-indigo-400" />
                    <span>Response Time: &lt; 24 Hours</span>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Right: Engineering Intake Form */}
            <motion.div
              {...fadeUp}
              transition={{ delay: 0.2 }}
              className="lg:col-span-8"
            >
              <div className="bg-white p-8 md:p-12 rounded-[2.5rem] border border-slate-100 shadow-xl shadow-slate-200/50 italic">
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-2 text-left">
                      <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                        Full Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full bg-slate-50 border border-slate-100 rounded-2xl px-5 py-4 text-sm focus:outline-none focus:border-indigo-500 focus:bg-white transition-all"
                        placeholder="John Doe"
                      />
                    </div>
                    <div className="space-y-2 text-left">
                      <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                        Corporate Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full bg-slate-50 border border-slate-100 rounded-2xl px-5 py-4 text-sm focus:outline-none focus:border-indigo-500 focus:bg-white transition-all"
                        placeholder="john@company.com"
                      />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-2 text-left">
                      <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                        Phone Reference (10 Digits)
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        className="w-full bg-slate-50 border border-slate-100 rounded-2xl px-5 py-4 text-sm focus:outline-none focus:border-indigo-500 focus:bg-white transition-all"
                        placeholder="8248387513"
                      />
                    </div>
                    <div className="space-y-2 text-left">
                      <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                        Organization
                      </label>
                      <input
                        type="text"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                        className="w-full bg-slate-50 border border-slate-100 rounded-2xl px-5 py-4 text-sm focus:outline-none focus:border-indigo-500 focus:bg-white transition-all"
                        placeholder="Enter Enterprise Name"
                      />
                    </div>
                  </div>

                  <div className="space-y-2 text-left">
                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                      Inquiry Vector
                    </label>
                    <textarea
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      required
                      className="w-full bg-slate-50 border border-slate-100 rounded-2xl px-5 py-4 text-sm h-32 focus:outline-none focus:border-indigo-500 focus:bg-white transition-all resize-none uppercase"
                      placeholder="Discuss your CRM infrastructure, AI data needs, or cloud migration..."
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-indigo-600 text-white py-4 rounded-2xl font-bold text-sm hover:bg-indigo-700 transition-all shadow-lg shadow-indigo-900/20 flex items-center justify-center gap-3 uppercase tracking-[0.2em]"
                  >
                    {loading ? (
                      <span className="flex items-center gap-2">
                        <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                        Synchronizing...
                      </span>
                    ) : (
                      <>
                        Transmit Message <Send size={16} />
                      </>
                    )}
                  </button>
                </form>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ================= GEOSPATIAL MAPPING SECTION ================= */}
      <section className="py-24 bg-slate-50 border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="text-left">
              <h2 className="text-3xl font-bold text-slate-900 mb-6 tracking-tight">
                Our Base of Operations
              </h2>
              <p className="text-slate-500 font-light leading-relaxed mb-8 uppercase italic tracking-tighter">
                Located at **72/3, SRP Mill Bus stop, Saravanampatti,
                Coimbatore**, we support global enterprises with high-fidelity
                software ecosystems, **CRM and Billing solutions**, and
                multilingual data translators.
              </p>
              <div className="flex flex-wrap gap-4">
                <div className="px-4 py-2 bg-white border border-slate-200 rounded-xl flex items-center gap-3 text-[10px] font-black uppercase tracking-widest text-slate-600 italic">
                  <Globe2 size={16} className="text-indigo-600" /> Remote Ready
                </div>
                <div className="px-4 py-2 bg-white border border-slate-200 rounded-xl flex items-center gap-3 text-[10px] font-black uppercase tracking-widest text-slate-600 italic">
                  <Activity size={16} className="text-indigo-600" /> 24/7
                  Monitoring
                </div>
              </div>
            </div>

            {/* Embedded Google Map  */}
            <div className="h-[400px] w-full rounded-[2.5rem] overflow-hidden border border-slate-200 shadow-2xl relative group">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3915.6322971203!2d76.9941!3d11.0772!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTHCsDA0JzM3LjkiTiA3NsKwNTknMzguOCJF!5e0!3m2!1sen!2sin!4v1700000000000"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="grayscale hover:grayscale-0 transition-all duration-700"
              ></iframe>
              <div className="absolute top-4 left-4 pointer-events-none">
                <div className="bg-[#0f172a]/90 backdrop-blur-md px-4 py-2 rounded-xl border border-white/10">
                  <p className="text-indigo-400 font-black text-[10px] uppercase tracking-[0.3em]">
                    Geospatial Node
                  </p>
                  <p className="text-white font-bold text-xs">
                    Saravanampatti, CBE
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactPage;